import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikInput } from "@air/formik-input";
import { Label } from "@air/primitive-label";
import classNames from "classnames";
import { memo } from "react";
export const AnonymousSignUpInput = /*#__PURE__*/ memo((param)=>{
    let { name, label, error } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex flex-col gap-2",
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                htmlFor: "anonymous-signup-".concat(name),
                size: "medium",
                children: [
                    label,
                    "*"
                ]
            }),
            /*#__PURE__*/ _jsx(FormikInput, {
                autoFocus: true,
                size: "extra-large",
                className: classNames("w-full", error ? "border-flamingo-600" : ""),
                id: "anonymous-signup-".concat(name),
                name: name,
                "data-testid": "ANONYMOUS_SIGN_UP_INPUT",
                "data-id": name
            }),
            !!error && /*#__PURE__*/ _jsx("div", {
                "data-testid": "ANONYMOUS_SIGN_UP_ERROR",
                "data-id": name,
                className: "absolute top-full w-full translate-y-0.5 text-12 text-flamingo-600",
                children: error
            })
        ]
    });
});
AnonymousSignUpInput.displayName = "AnonymousSignUpInput";
